import React from 'react';

function AuthorHeader(props) {
  const { authorData } = props;

  if (!authorData) {
    return null;
  }

  return (
    <section className="my-12 mx-4 flex flex-col sm:flex-row author">
      <div className="author-image">
        <img
          draggable={false}
          src={
            authorData.Avatar?.url?.replace('/origin/', '/small/') ||
            'https://d2nb51khh83712.cloudfront.net/static-assets/images/inv-logo.png'
          }
          alt={authorData.Name}
        />
      </div>
      <div className="author-content ml-6">
        <h1 className="text-3xl mt-0 mb-4">{authorData.Name}</h1>
        {authorData.URL && (
          <p className="author-website">
            <a href={authorData.URL} target="_blank" rel="noreferrer noopener">
              {authorData.URL}
            </a>
          </p>
        )}
        {authorData.AuthorDescription && (
          <p className="font-normal mt-4 author-description">
            {authorData.AuthorDescription}
          </p>
        )}
        {authorData.AuthorSocialLinks && (
          <div className="author-social mt-4">
            {authorData.AuthorSocialLinks.Twitter && (
              <a
                href={authorData.AuthorSocialLinks.Twitter}
                target="_blank"
                rel="noreferrer noopener"
                className="flex"
              >
                <img
                  src="https://web-assets.invideo.io/common/prod/social-icons/icon-twitter.svg"
                  alt="logo"
                  width="25"
                  height="25"
                />
              </a>
            )}

            {authorData.AuthorSocialLinks.Facebook && (
              <a
                href={authorData.AuthorSocialLinks.Facebook}
                target="_blank"
                rel="noreferrer noopener"
                className="flex"
              >
                <img
                  src="https://web-assets.invideo.io/common/prod/social-icons/icon-fb.svg"
                  alt="logo"
                  width="25"
                  height="25"
                />
              </a>
            )}

            {authorData.AuthorSocialLinks.Instagram && (
              <a
                href={authorData.AuthorSocialLinks.Instagram}
                target="_blank"
                rel="noreferrer noopener"
                className="flex"
              >
                <img
                  src="https://web-assets.invideo.io/common/prod/social-icons/icon-snap.svg"
                  alt="logo"
                  width="25"
                  height="25"
                />
              </a>
            )}

            {authorData.AuthorSocialLinks.Youtube && (
              <a
                href={authorData.AuthorSocialLinks.Youtube}
                target="_blank"
                rel="noreferrer noopener"
                className="flex"
              >
                <img
                  src="https://web-assets.invideo.io/common/prod/social-icons/icon-yt.svg"
                  alt="logo"
                  width="25"
                  height="25"
                />
              </a>
            )}

            {authorData.AuthorSocialLinks.Linkedin && (
              <a
                href={authorData.AuthorSocialLinks.Linkedin}
                target="_blank"
                rel="noreferrer noopener"
                className="flex"
              >
                <img
                  src="https://web-assets.invideo.io/common/prod/social-icons/icon-in.svg"
                  alt="logo"
                  width="25"
                  height="25"
                />
              </a>
            )}
          </div>
        )}
      </div>
    </section>
  );
}

export default AuthorHeader;
